import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { localStorageKeys, removeLocalstorageItem } from '@/helpers/localStorage';
import router from '@/router';
import { useI18n } from 'vue-i18n';
import { getKeycloak } from '@/helpers/keycloak';
import { useMonitoringRealTimeStore } from '@/store/monitoringRealTime';
import moment from 'moment';
import { useApi } from '@/composables/useApi';

export const useUserStore = defineStore('userStore', () => {
  const user = ref();
  const i18n = useI18n();
  const { apiGet } = useApi();

  const { unsubscribeBroadcast } = useMonitoringRealTimeStore();

  const userLocale = computed(() => user.value?.locale);
  const userLoggedIn = computed(() => user.value !== undefined);

  async function updateUser() {
    const data = await apiGet('/auth/me', false);
    if (data === undefined) {
      console.log('Api did not return customer data.');
      return;
    }

    resetCache();
    user.value = {
      id: data.customerIds,
      email: data.email,
      locale: data.languageCode.toLowerCase(),
      countryCode: data.countryCode,
      devices: data.devices,
    };
    i18n.locale.value = user.value.locale;
    moment.locale(user.value.locale);
  }

  async function logoutUser() {
    resetCache();
    unsubscribeBroadcast();

    user.value = undefined;

    const keycloak = await getKeycloak();
    keycloak.logout();

    router.push({ path: '/login' });
  }

  function resetCache() {
    removeLocalstorageItem(localStorageKeys.installations);

    Object.keys(localStorage)
      .filter((key) => key.startsWith(localStorageKeys.monitoring))
      .forEach((key) => localStorage.removeItem(key));
  }

  return {
    user,
    userLoggedIn,
    userLocale,
    updateUser,
    logoutUser,
  };
});
